import loadable from '@loadable/component';

export const CmsReactionsLoadable = loadable(() => import('./CmsReactions'), {
  resolveComponent: (module) => module.CmsReactions,
  ssr: false,
});
